import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import styles from "./Pools.module.scss";
import Durations from "../../components/Durations/Durations";
import LearnMore from "../../components/LearnMore/LearnMore";
import FrequentlyQuestions from "../../components/FrequentlyQuestions/FrequentlyQuestions";
import ContactUs from "../../components/ContactUs/ContactUs";
import { PUBLIC_ICON } from "../../constants";

const Pools = () => {
  useEffect(() => {
    const bodyOverflowX = document.body.style.overflowX;
    const htmlOverflowX = document.documentElement.style.overflowX;
    document.body.style.overflowX = "hidden";
    document.documentElement.style.overflowX = "hidden";
    return () => {
      document.body.style.overflowX = bodyOverflowX;
      document.documentElement.style.overflowX = htmlOverflowX;
    };
  }, []);

  return <>
    <Helmet><title>Pools</title><link rel="icon" href={PUBLIC_ICON + "Alfa.svg"} /></Helmet>
    <main className={styles.main__pools}><div className={styles.main__wrapper}>
      <Durations key="best-rate-v5" />
      <LearnMore />
      <FrequentlyQuestions />
      <ContactUs />
    </div></main>
  </>;
};
export default Pools;
